module.exports = __webpack_public_path__ + "img/typing.75f11ab.png";